import './App.css'
import BrowserSearch from './components/TabSearches'
// These are the list used in the application. You can move them to any component needed.

// Replace your code here
const App = () => <BrowserSearch />

export default App